import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useGetPointBalance from "@/components/wallet/hooks/useGetPointBalance";
import WalletLayout, { POINT_TAB_VALUE } from "@/components/wallet/Layout";
import PointTransaction from "@/components/wallet/PointTransaction";
import useRedirect from "@/hooks/useRedirect";
import useSearchParams from "@/hooks/useSearchParams";
import { useAuthStore } from "@/lib/auth/AuthStore";
import { CASH_INDEX_PAGE, POINT_INDEX_PAGE, REGISTRATION_PAGE } from "@/settings/constant";
import { Spinner, TabContent, Tabs, Typography } from "@bookips/sds";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { useDialogStore } from "src/store/useDialogStore";
import useSnackbar from "src/store/useSnackbar";
export const POINT_HISTORY_TAB_VALUE = "history";
const tabList = [
    {
        value: POINT_HISTORY_TAB_VALUE,
        label: "포인트 내역"
    }
];
const PointPage = ()=>{
    var _error_response, _pointBalance_totalBalance;
    const router = useRouter();
    const searchParams = useSearchParams();
    const { open , close  } = useDialogStore();
    const { addSnackbar  } = useSnackbar();
    const { redirectTo , redirectToLogin  } = useRedirect();
    var _searchParams_get;
    const activeTab = (_searchParams_get = searchParams.get("tab")) !== null && _searchParams_get !== void 0 ? _searchParams_get : POINT_HISTORY_TAB_VALUE;
    const { isLoggedIn  } = useAuthStore();
    const { data: pointBalance , isLoading , isError , error  } = useGetPointBalance();
    const is500Error = isError && (error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status) === 500;
    const showLoginRequiredDialog = ()=>{
        open({
            id: "login-required",
            type: "confirm",
            props: {
                title: "로그인이 필요해요.",
                description: "로그인 또는 회원가입을 진행해주세요.",
                confirmText: "회원가입",
                cancelText: "로그인",
                onConfirm: ()=>{
                    redirectTo(REGISTRATION_PAGE, "".concat(POINT_INDEX_PAGE, "?tab=").concat(POINT_HISTORY_TAB_VALUE));
                },
                onCancel: ()=>{
                    redirectToLogin("".concat(POINT_INDEX_PAGE, "?tab=").concat(POINT_HISTORY_TAB_VALUE));
                },
                contentProps: {
                    onInteractOutside: ()=>{
                        close("login-required");
                    }
                }
            }
        });
    };
    useEffect(()=>{
        if (activeTab === POINT_HISTORY_TAB_VALUE && !isLoggedIn) {
            router.replace(CASH_INDEX_PAGE);
            showLoginRequiredDialog();
        }
    }, [
        activeTab,
        isLoggedIn
    ]);
    useEffect(()=>{
        if (is500Error) {
            addSnackbar({
                message: "다시 시도해주세요.",
                variant: "error"
            });
        }
    }, [
        is500Error
    ]);
    if (activeTab === POINT_HISTORY_TAB_VALUE && !isLoggedIn) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(WalletLayout, {
        tabValue: POINT_TAB_VALUE,
        children: [
            isLoggedIn && /*#__PURE__*/ _jsxs("div", {
                className: "px-6 py-5 bg-white rounded-md border border-gray-100 flex items-center gap-2",
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "h6",
                        className: "text-primary",
                        children: "보유 포인트"
                    }),
                    isLoading || is500Error ? /*#__PURE__*/ _jsx(Spinner, {
                        size: "sm",
                        className: "text-primary-main"
                    }) : /*#__PURE__*/ _jsxs(Typography, {
                        variant: "h6",
                        className: "text-mint-400",
                        children: [
                            pointBalance === null || pointBalance === void 0 ? void 0 : (_pointBalance_totalBalance = pointBalance.totalBalance) === null || _pointBalance_totalBalance === void 0 ? void 0 : _pointBalance_totalBalance.toLocaleString(),
                            "원"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Tabs, {
                tabs: tabList,
                value: activeTab,
                classes: {
                    list: "pt-1 bg-white border border-gray-100 border-b-0 rounded-t-md",
                    listContent: "pl-5 max-w-[598px] w-full"
                },
                onValueChange: (value)=>{
                    if (!isLoggedIn && value === POINT_HISTORY_TAB_VALUE) {
                        showLoginRequiredDialog();
                        return;
                    }
                    router.push({
                        pathname: router.pathname,
                        query: {
                            tab: value
                        }
                    });
                },
                children: /*#__PURE__*/ _jsx(TabContent, {
                    value: POINT_HISTORY_TAB_VALUE,
                    children: /*#__PURE__*/ _jsx(PointTransaction, {})
                })
            })
        ]
    });
};
export default PointPage;
